export default __webpack_public_path__ + "static/media/currency.39af427d.jpg";